










































































import Component from "vue-class-component";
import { Vue } from "vue-property-decorator";
import { Machine, machineStore } from "@/utils/machine";

@Component
export default class MachineForm extends Vue {
  public machine: Machine = machineStore.get();

  valid = true;
  name = "";

  requiredRule(name: string) {
    return (v) => !!v || `${name} is required`;
  }

  validate() {
    //@ts-ignore
    this.$refs.form.validate();
    machineStore.set(this.machine);
  }

  clear() {
    machineStore.clear();
    this.machine = machineStore.get();
  }

  reset() {
    //@ts-ignore
    this.$refs.form.reset();
  }

  resetValidation() {
    //@ts-ignore
    this.$refs.form.resetValidation();
  }
}
